<template>
  <ToastContainer />
  <ConfirmModal
    v-if="state.options"
    :open="state.open"
    :title="state.options.title ?? 'Confirmar acción'"
    :message="state.options.message"
    :confirm-label="state.options.confirmLabel"
    :cancel-label="state.options.cancelLabel"
    :variant="state.options.variant"
    :secondary-action="state.options.secondaryAction"
    :tertiary-action="state.options.tertiaryAction"
    @confirm="onConfirm"
    @cancel="onCancel"
    @secondary="onSecondary"
    @tertiary="onTertiary"
  />
  <ImpersonationTransitionOverlay />
</template>

<script setup lang="ts">
import ToastContainer from './ToastContainer.vue'
import ConfirmModal from './ConfirmModal.vue'
import ImpersonationTransitionOverlay from './ImpersonationTransitionOverlay.vue'
import { _useConfirmState, _resolveConfirm } from '~/composables/useConfirm'

const state = _useConfirmState()

function onConfirm()   { _resolveConfirm('confirm') }
function onCancel()    { _resolveConfirm('cancel') }
function onSecondary() { _resolveConfirm('secondary') }
function onTertiary()  { _resolveConfirm('tertiary') }
</script>
